import React from 'react';
import SgsstCrudPage from '../components/SgsstCrudPage';
import { sgsstMatrizLegal } from '../services/api';

const TIPO = { ley: 'Ley', decreto: 'Decreto', resolucion: 'Resolución', circular: 'Circular', otra: 'Otra' };

export default function SgsstMatrizLegal() {
  return (
    <SgsstCrudPage
      title="Matriz legal"
      sub="Requisitos legales aplicables al SG-SST y su cumplimiento."
      newLabel="+ Nueva norma"
      api={sgsstMatrizLegal}
      vacio={{ tipo_norma: 'ley', numero: '', anio: '', articulo: '', tema: '', descripcion: '', aplica: true, cumple: false, evidencia: '' }}
      columns={[
        { k: 'tipo_norma', h: 'Tipo', map: TIPO }, { k: 'numero', h: 'Número', strong: true }, { k: 'anio', h: 'Año', mono: true },
        { k: 'tema', h: 'Tema' }, { k: 'aplica', h: 'Aplica', fmt: 'bool' }, { k: 'cumple', h: 'Cumple', fmt: 'bool' },
      ]}
      fields={[
        { k: 'tipo_norma', l: 'Tipo de norma', type: 'select', opts: Object.entries(TIPO) }, { k: 'numero', l: 'Número', type: 'text' },
        { k: 'anio', l: 'Año', type: 'number' }, { k: 'articulo', l: 'Artículo(s)', type: 'text' },
        { k: 'tema', l: 'Tema', type: 'text', full: true }, { k: 'descripcion', l: 'Descripción / requisito', type: 'textarea', full: true },
        { k: 'aplica', l: '¿Aplica?', type: 'bool' }, { k: 'cumple', l: '¿Cumple?', type: 'bool' },
        { k: 'evidencia', l: 'Evidencia', type: 'text', full: true },
      ]}
    />
  );
}
